import { z } from "zod";

import { ProviderEnum } from "@/core/constants";

const tenDigits = /^\d{10}$/;

export const newProviderSchema = z
  .object({
    accept_new_patients: z.boolean(),
    address: z.object({
      city: z.string().min(1, "City is required"),
      state: z.string().min(1, "State is required"),
      street: z.string().min(1, "Street is required"),
      zip_code: z.string().min(1, "Zip code is required"),
    }),
    cp_credentials: z.array(z.string()).min(1, "Credentials are required"),
    intake_practice_ids: z.array(z.string()).nullable(),
    mobile: z
      .string()
      .regex(tenDigits, "Mobile number must be 10 digits")
      .or(z.literal(""))
      .optional(),
    name: z.string().min(1, "Name is required"),
    npi_number: z.string().regex(tenDigits, "NPI number must be 10 digits").or(z.literal("")),
    practice: z.string(),
    provider_type: z.nativeEnum(ProviderEnum, { message: "Provider type is required" }),
    Username: z.string().email("Enter a valid email address"),
  })
  .superRefine((data, ctx) => {
    if (data.provider_type !== "CARE_MANAGER" && !data.npi_number) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "NPI Number is required",
        path: ["npi_number"],
      });
    }
  });

export type NewProviderFormValues = z.infer<typeof newProviderSchema>;

export const NEW_PROVIDER_DEFAULT_VALUES: NewProviderFormValues = {
  accept_new_patients: true,
  address: { city: "", state: "", street: "", zip_code: "" },
  cp_credentials: [],
  intake_practice_ids: null,
  mobile: "",
  name: "",
  npi_number: "",
  practice: "",
  provider_type: "PCP",
  Username: "",
};
